// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-ad21df52] .input1 .el-input__inner {\n  color: #CB582E;\n}\n.box[data-v-ad21df52] {\n  display: flex;\n  justify-content: space-around;\n}\n.box p[data-v-ad21df52] {\n    font-size: 0.2rem;\n}\n.box p span[data-v-ad21df52] {\n      color: #CB582E;\n}\n", ""]);
// Exports
module.exports = exports;
